import { render, staticRenderFns } from "./SelectCountryOnboarding.vue?vue&type=template&id=5d681f28&scoped=true&"
import script from "./SelectCountryOnboarding.vue?vue&type=script&lang=js&"
export * from "./SelectCountryOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SelectCountryOnboarding.vue?vue&type=style&index=0&id=5d681f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d681f28",
  null
  
)

export default component.exports